import FeatherIcon from 'feather-icons-react';
import { Badge, Card, Col, Row, Spinner } from 'react-bootstrap';

import { currencyFormatter } from '../helpers/currencyFormatter';
import { KpiMetric } from '../types/dashboard';

const KPI_CARD_MIN_HEIGHT = 92;

interface AnalyticsTotalHoursProps {
  data?: KpiMetric;
  isLoading?: boolean;
}

export default function AnalyticsTotalHours({ data, isLoading, ...props }: AnalyticsTotalHoursProps) {
  const hasData = !isLoading && data !== undefined;
  const changePercent = data?.changePercent ?? 0;
  const isPositive = changePercent >= 0;

  return (
    <Card {...props}>
      <Card.Body style={{ minHeight: KPI_CARD_MIN_HEIGHT }}>
        <Row className="align-items-center h-100">
          <Col>
            <h6 className="text-uppercase text-muted mb-2">Total Expenses</h6>
            {isLoading ? (
              <Spinner animation="border" size="sm" />
            ) : hasData ? (
              <>
                <span className="h2 mb-0">{currencyFormatter(data.value)}</span>
                <Badge bg={isPositive ? 'danger-soft' : 'success-soft'} className="mt-n1 ms-2">
                  {isPositive ? '+' : ''}
                  {changePercent.toFixed(1)}%
                </Badge>
              </>
            ) : (
              <span className="h2 mb-0 text-muted">No data available</span>
            )}
          </Col>
          <Col xs="auto">
            <FeatherIcon icon="trending-down" size="20" className="text-muted" />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
